module.exports = __webpack_public_path__ + "static/media/previous.630e9242.svg";